module.exports = __webpack_public_path__ + "static/img/QYQB.d9f5e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/QYQB.jpg
// module id = OJpt
// module chunks = 1